export enum LineType {
    Linear,
    Natural,
    StepLine,
    StepLineBefore,
    StepLineAfter,
    MonotoneX
 }